import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // console.log("connect::front-controller");

    const page = document.querySelector(".layout-wrapper");

    // procesa las imágenes del artículo quitando espacios en blanco no deseados
    if (page && page.classList.contains("check-wyiswyg-content")) {
      const article = document.querySelector("article");
      const articleImgs = article.querySelectorAll("p > img, p picture img.desktop-img");

      for (let img of articleImgs) {
        let imgWrapper = img.parentNode;

        let source = imgWrapper.querySelector("source");

        if (source) {
          imgWrapper.parentNode.innerHTML = imgWrapper.parentNode.innerHTML.replace(/&nbsp;/g, '');
        }
      }
    }
  }
}
